import React, { useState } from "react";
import styled from "styled-components";
import theme from "../../styles/theme";
import Skeleton from "@mui/material/Skeleton";

import { isDark } from "../../utils/helpers/colors";
import noTeamImg from "../../assets/Teams/2024/mercedes.png";

const DriverBottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding-top: 15px;
  max-width: 100%;
  z-index: 2;
`;
const DriverName = styled.div`
  font-size: 12px;
  font-weight: 600;
  transition: color 0.3s ease;
`;

const DriverTeam = styled.div`
  font-size: 24px;
  transition: color 0.3s ease;
`;

const DriverTopContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: end;
  width: 100%;
  padding: 0px;
`;

const Border = styled.div`
  border-top: 4px solid ${(props) => props.color};
  background-color: ${(props) => props.color};
  max-width: 350px;
  height: 0px;
  position: absolute;
  width: 100%;
  top: 68%;
  z-index: 2;
`;

const StyledImg = styled.img`
  object-fit: contain;
  z-index: 1;
  width: 100%;
  height: 100%;
  margin-top: 83px;
  @media (max-width: ${theme.breakpointsCustom.md}px) {
    max-width: 280px;
    height: 95px;
  }
  transition: all 0.7s linear;
  opacity: ${(props) => `${props.loaded ? "1" : "0"}`};
`;

const DefaultImage = styled.img`
  object-fit: contain;
  z-index: 2;
  min-height: 94px;
  width: 100%;
  margin-top: 83px;
  @media (max-width: ${theme.breakpointsCustom.md}px) {
    max-width: 280px;
    height: 95px;
  }

  opacity: ${(props) => `${props.loaded ? "0" : "1"}`};
  position: absolute;
  transition: all 0.7s linear;
`;

const DriverContainer = styled.div`
  background-color: ${theme.colors.darkLight};
  box-shadow: 0px 0px 4px ${(props) => props.colorShadow};
  max-width: 360px;
  max-height: 285px;
  z-index: 2;
  width: 100%;
  padding: 20px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: "Montserrat", sans-serif;
  border-radius: 4px;
  overflow: hidden;

  &:hover ${DriverName}, &:hover ${DriverTeam} {
    color: ${(props) => (isDark(props.color) ? theme.colors.white : theme.colors.darkLight)};
  }
  &:hover ${StyledImg} {
    transition: transform 0.5s;
    transform: scale(1.08);
  }
  &:hover ${Border} {
    max-width: 100%;
    height: 32%;
    transition:
      max-width 0.1s ease,
      height 0.1s ease 0.1s;
  }
  &:not(:hover) ${Border} {
    height: 0px;
    max-width: 90%;
    transition:
      height 0.2s ease 0s,
      max-width 0.2s ease 0.2s;
  }
  &:not(:hover) ${StyledImg} {
    transition: transform 0.5s 0s;
  }
  @media (max-width: ${theme.breakpointsCustom.md}px) {
    max-width: 500px;
  }
`;
// const Position = styled.div`
//   color: ${theme.colors.white};
//   height: 90px;
//   width: 33px;
//   background: ${(props) => props.color};
//   position: absolute;
//   top: -12%;
//   left: -3%;
//   transform: rotate(45deg);
// `;

const PointsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  top: 0%;
  right: 5%;
`;

const Points = styled.div`
  color: ${theme.colors.white};
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  width: 85px;
  background: ${theme.colors.dark};
`;
const PointsText = styled.div`
  color: ${theme.colors.dark};
  text-align: center;
  width: 85px;
  font-size: 24px;
  font-weight: 600;
  background: ${theme.colors.white};
`;

const DriverInfo = styled.div``;

export const PodiumConstructor = ({ team, points, position }) => {
  const [loaded, setLoaded] = useState(false);

  const { color, name, livery, drivers } = team;

  let positionColor = theme.colors.bronze;
  if (position === 1) positionColor = theme.colors.gold;
  if (position === 2) positionColor = theme.colors.silver;

  return (
    <DriverContainer color={color} colorShadow={positionColor}>
      {/* <Position color={positionColor}></Position> */}
      <PointsContainer>
        <Points>{points}</Points>
        <PointsText>{`ОЧ.`}</PointsText>
      </PointsContainer>
      <DriverTopContainer>
        <DefaultImage src={noTeamImg} loaded={loaded} />
        <StyledImg src={livery?.image} onLoad={() => setLoaded(true)} loaded={loaded} />
      </DriverTopContainer>
      <Border color={color} />
      <DriverBottomContainer>
        <DriverInfo>
          <DriverTeam>{name}</DriverTeam>
          <DriverName>
            {drivers.map((driver) => `${driver.firstName} ${driver.lastName}`).join(" / ")}
          </DriverName>
        </DriverInfo>
      </DriverBottomContainer>
    </DriverContainer>
  );
};

export const PodiumConstructorSkeleton = () => {
  return (
    <DriverContainer style={{ minHeight: "287px" }}>
      <Skeleton
        height="90px"
        width="33px"
        style={{
          borderRadius: "0px",
          position: "absolute",
          top: "-16%",
          left: "-1%",
          transform: "rotate(45deg)",
        }}
      />
      <PointsContainer style={{ top: "-9%" }}>
        <Skeleton height="95px" width="80px" style={{ borderRadius: "0px" }} />
      </PointsContainer>
      <DriverTopContainer style={{ height: "150px" }}>
        <Skeleton
          style={{
            borderRadius: "15px",
            maxWidth: "270px",
            width: "100%",
            height: "110px",
            marginTop: "0px",
            marginLeft: "0px",
          }}
        />
      </DriverTopContainer>
      <Skeleton height="12px" width="100%" style={{ borderRadius: "0px" }} />
      <DriverBottomContainer style={{ paddingTop: "0px", marginLeft: "10px" }}>
        <DriverInfo>
          <DriverName>
            <Skeleton height="41px" width="150px" style={{ borderRadius: "12px" }} />
          </DriverName>
          <DriverTeam>
            <Skeleton height="20px" width="115px" style={{ borderRadius: "12px" }} />
          </DriverTeam>
        </DriverInfo>
      </DriverBottomContainer>
    </DriverContainer>
  );
};
